<bp-get-started-form
	[entity]="_entity"
	[buttonText]="buttonText"
	[error]="_currentCrmLeadFacade.error$ | async"
	[pending]="_pending$ | async"
	(submitted)="_saveCrmLead($event)"
/>
